<template>
  <ul class="table-breadcrumbs">
    <li v-if="sharedItemMode">
      <a
        :href="documentsUrl"
        class="text-blue font-bold"
        v-text="'Shared Folders'"
      />
    </li>
    <li v-else>
      <a
        :href="documentsUrl"
        class="text-blue font-bold"
        v-text="'Documents'"
      />
    </li>
    <li
      v-for="(ancestor, index) in ancestors"
      :key="`ancestor-${index}`"
    >
      <a
        :href="ancestorUrl(ancestor)"
        class="text-blue font-bold"
        v-html="ancestor.attributes.title"
      />
    </li>
    <li>
      <a
        :href="currentFolderUrl"
        v-text="currentFolder"
      />
    </li>
  </ul>
</template>

<script type="text/babel">
export default {
  name: 'FolderBreadcrumbs',
  props: {
    currentFolder: {
      type: String,
      required: true,
    },
    currentFolderUuid: {
      type: String,
      required: true,
    },
    ancestors: {
      type: Array,
      required: true,
    },
    sharedItemMode: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    documentsUrl() {
      return this.sharedItemMode
        ? this.$urlGenerator.active('documents/shares/folders')
        : this.$urlGenerator.active('documents')
    },
    currentFolderUrl() {
      return this.sharedItemMode
        ? this.$urlGenerator.active(`documents/shares/folders/${this.currentFolderUuid}`)
        : this.$urlGenerator.active(`documents/folders/${this.currentFolderUuid}`)
    },
  },
  methods: {
    ancestorUrl(ancestor) {
      return this.sharedItemMode
        ? this.$urlGenerator.active(`documents/shares/folders/${ancestor.uuid}`)
        : this.$urlGenerator.active(`documents/folders/${ancestor.uuid}`)
    },
  },
}
</script>
